/**
 * @description 评论保存接口
 * @author duanjun
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType, CommentType } from '@umu/umu-types';

interface IInput {
    parent_type: CommentParentType;
    comment_type: CommentType;
    comment_id: number;
    comment: string;
}

interface IOutput {
    comment_info: IComment;
}

export type IResponseData = IResponse<IOutput>;

export const editComment = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(
        Api.EDIT_COMMENT,
        Object.assign(
            {
                // show_parent_id: 0,
                // comment_parent_id: 0,
            },
            data,
        ),
    ).then((res: IResponseData) => {
        return res;
    });
};
